import * as React from 'react';
import styled, { useTheme } from 'styled-components';
import { Anchor, Flex, Text } from '../../../components/blocks';

import ImgTel from '../../../images/banner/img-tel.svg';

type Props = {
  wide?: 'm' | 'l';
  appearance?: 'border';
};

const Root = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spaces.xl};
  background: ${({ theme }) => theme.backgroundColors.white};
  border-radius: ${({ theme }) => theme.radii.m};

  ${({ theme }) =>
    theme.screen.sp({
      flexDirection: 'column',
      gap: theme.spaces.l,
    })}

  ${({ theme, wide = 'm' }) => {
    switch (wide) {
      case 'm':
        return {
          maxWidth: theme.windowSizes.m,
        };
      case 'l': {
        return {
          width: '100%',
        };
      }
    }
  }};

  ${({ theme, appearance }) => {
    switch (appearance) {
      case 'border':
        return {
          border: `1px solid ${theme.borderColors.default}`,
        };
    }
  }};
`;

const Tel = styled(Flex)`
  gap: ${({ theme }) => theme.spaces.m};

  img,
  svg {
    margin-top: 4px;
  }

  ${({ theme }) =>
    theme.screen.sp({
      alignItems: 'center',
    })};
`;

export const Banner: React.FC<Props> = (props) => {
  const theme = useTheme();

  return (
    <Root wide={props.wide} appearance={props.appearance}>
      <Text as="h2" size="l" fontWeight="bold">
        <ruby>
          Dentis<rt>デンティス</rt>
        </ruby>
        に関するお問い合わせ
      </Text>
      <Tel flexDirection="column" alignItems="flex-start">
        <Flex flexDirection="column" alignItems="flex-start">
          <Text size="s" display="block" fontWeight="bold">
            株式会社メドレー Dentis事業推進室
          </Text>
          <a href="tel:050-1751-0849">
            <Flex alignItems="center" gap={theme.spaces.s}>
              <ImgTel width="24px" alt="tel" />
              <Text size="xxxl" fontWeight="bold">
                050-1751-0849
              </Text>
            </Flex>
          </a>
          <Text size="xs" display="block">
            受付時間：10:00〜18:00（土日祝・年末年始休み）
          </Text>
        </Flex>
      </Tel>
      <Anchor to="/form/inquiry" radius="rounded" wide="l">
        お問い合わせ
      </Anchor>
    </Root>
  );
};
